// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2ndOe","title":"Header_title__27_GJ","side":"Header_side__1Qj8j"};